import React from 'react'
import Svg, { Path, SvgProps } from 'react-native-svg'

import { Color } from '../../style'

export interface Props extends SvgProps {}
const IconUpload = (props: Props) => {
  const { width, height, color, ...otherProps } = props
  return (
    <Svg
      width={width}
      height={height}
      viewBox={`0 0 ${IconUpload.dimensions.width} ${IconUpload.dimensions.height}`}
      {...otherProps}
    >
      <Path
        fill={color || Color.premiumBlack}
        d="M.5 14.461c.142-.555.245-1.122.432-1.66.333-.94.905-1.723 1.658-2.36a.605.605 0 0 0 .227-.489c.075-2.335 1.958-4.46 4.22-4.78 1.047-.15 1.61-.075 2.897.385.055-.106.113-.211.168-.322 1.507-3.039 3.9-4.817 7.207-5.182 4.02-.441 7.704 1.891 9.199 5.743.088.226.215.323.437.382 3.008.787 5.11 3.24 5.498 6.405.01.072.037.142.057.214v1.282c-.023.113-.047.226-.065.339-.458 2.939-2.027 4.986-4.73 6.076-.637.257-1.345.339-2.02.5h-4.874c-.345-.207-.455-.405-.368-.685.103-.324.363-.378.65-.378 1.48-.005 2.96.016 4.438-.026 2.857-.082 5.46-2.51 5.847-5.41.45-3.363-1.368-6.292-4.5-7.248-.09-.028-.183-.072-.273-.07-.622.014-.83-.37-1.042-.916-1.145-2.922-3.26-4.692-6.307-5.108-3.88-.53-7.257 1.667-8.584 5.444-.06.167-.123.334-.155.421-.658-.264-1.273-.598-1.928-.757-2.16-.527-4.44 1.143-4.712 3.404-.035.285.013.583-.047.858a.965.965 0 0 1-.315.498A5.633 5.633 0 0 0 2.14 12.62c-1.633 2.87.157 6.732 3.362 7.233.358.056.725.08 1.088.08 1.697.007 3.394.002 5.094.002h.22c.288 0 .555.056.648.38.097.34-.088.545-.365.686H5.875c-.08-.02-.158-.049-.238-.062-2.375-.395-4.01-1.726-4.832-4.056-.143-.414-.205-.848-.305-1.27V14.46v.002Z"
      />
      <Path
        fill={color || Color.premiumBlack}
        d="M16.376 20.993c-.3-.147-.39-.393-.39-.727.007-2.89.005-5.783.005-8.674v-.426c-.125.115-.208.185-.283.262l-4.044 4.139c-.08.082-.163.167-.255.236-.225.165-.46.15-.653-.046-.195-.195-.202-.434-.057-.67a.953.953 0 0 1 .14-.17c1.854-1.901 3.712-3.803 5.57-5.704.022-.023.047-.038.094-.074.08.077.163.151.24.23l5.325 5.455c.362.373.422.689.177.935-.252.255-.532.198-.91-.19-1.34-1.372-2.682-2.746-4.017-4.12-.077-.083-.12-.201-.18-.301l-.127.082v.331c0 2.904-.003 5.804.005 8.707 0 .334-.093.578-.393.727h-.25l.003-.002Z"
      />
    </Svg>
  )
}

IconUpload.dimensions = {
  width: 33,
  height: 21,
}

export default IconUpload
